import { createAsyncThunk } from '@reduxjs/toolkit';
import { getInvoicePayment } from '../services/getInvoicePayment.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const getInvoicePaymentThunk = createAsyncThunk(
  'payments/getInvoicePayment',
  async ({ projectId, invoiceId }, { getState, rejectWithValue }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    try {
      return await getInvoicePayment(projectId, invoiceId, activeEmployerInfo);
    } catch (error) {
      // 404 just means this invoice has never been paid, which is the normal
      // state for most of them — not an error worth surfacing.
      if (error?.response?.status === 404) return null;
      return rejectWithValue({ message: error?.message });
    }
  }
);
